import { BaseRequestService, CacheService, ConfigService } from '@outlaw/core';
import { inject, Injectable } from '@angular/core';
import { CommunityConfiguration, CommunityGroupUser } from '../../interfaces';
import { Observable } from 'rxjs';
import { CommunityConfigService } from './community-config.service';

@Injectable({ providedIn: 'root' })
export class ConfigurationService {
  private configurationUrl = inject(ConfigService).apiConfig.configurationUrl;
  private baseRequestService = inject(BaseRequestService);
  private cacheService = inject(CacheService);
  private communityConfigService = inject(CommunityConfigService);
  private postUrl = this.communityConfigService.internalApi.postUrl;

  getCachedConfiguration(communityUUID: string): Observable<CommunityConfiguration> {
    return this.cacheService.cacheRequest<CommunityConfiguration>(
      `configuration-req-${communityUUID}`,
      this.baseRequestService.prepareUrl([this.configurationUrl, communityUUID])
    );
  }

  getCachedGroupUsers(groupId: string): Observable<CommunityGroupUser[]> {
    // users_display returns the same members as users but in the order configured
    // in Django admin, so the artists list can be sorted from the backend.
    return this.cacheService.cacheRequest<CommunityGroupUser[]>(
      `group-users-${groupId}`,
      this.baseRequestService.prepareUrl([this.postUrl, 'community-groups', groupId, 'users_display'])
    );
  }
}
